<template>
  <div class="sharePosterBox">
        <div class="sharePoster">
            <div class="swiperbox" v-show='isShow=="1"'>  
                 <div  class="swiper-container" id="picList">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide box" v-for="(item,index) in bgList" :key="index" :style="{'margin-top':'0px'}">
                            <div :class="'onePic'+index">
                                <div class="bgPic">
                                    <img class="sPage" crossorigin="*" :src="item.image+'?'+Date.now().toString()"  :index='item.id' alt="" style="width:100%;">
                                </div>
                                <div class="toptxt">
                                    <p class="hostName">{{hostName}}</p>
                                    <p class="stationName">{{stationName}}</p>
                                </div>
                                <div class="lefttxt">
                                    <!-- <img src="../../assets/img/wuhanImg/wechat_share.png" alt="">
                                    <span class="userName">userName</span> -->
                                    <img :src="userAvatar" alt="">
                                    <!-- <img  src="http://seefm.oss-cn-beijing.aliyuncs.com/avatar/l3ao599p2hsk8og0sg.png" alt=""> -->
                                    <span class="userName">{{userName}}</span>
                                </div>
                                <div class="btmtxt">
                                    <p>扫描二维码</p>
                                    <p>查收女神节祝福</p>
                                </div>
                                <div class="invitation" :class='"invitation"+index' >
                                    <div class="qrcode">
                                        <vue-qr
                                           
                                            :text="loginUrl"
                                            :size="200"
                                            :margin="16"
                                            whiteMargin ='true'
                                            ref="Qrcode"
                                            class="vue-qr-img"
                                            :callback='callback'
                                            >
                                        </vue-qr>
                                    </div>
                    
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <img class="prev swiper-button-prev" src="../../assets/img/fission/prev.png" alt="" srcset="">
                <img class="next swiper-button-next" src="../../assets/img/fission/next.png" alt="" srcset="">  -->
            </div>
            <!-- <img @click="easyCopy" src="../../assets/img/fission/easyCopy.png" alt=""> -->
            <div class="easyCopy"  v-if="isapp=='1'">分享海报</div>
            <!-- <div class="bottom_btn" v-if='isShow=="1"&&isapp=="0"'>
                <img class="poster" @click.stop="todownload()" :disabled="isClick" src="../../assets/img/wuhanImg/poster_btn1.png" alt="" srcset="">
                <img class="download" @click.stop="getimg()"  :disabled="isClick" src="../../assets/img/wuhanImg/poster_btn.png" alt="" srcset="">
            </div> -->
            <div class="shareButton" v-if="isapp=='1'">
                <p @click.stop="getimg(1,1)">
                    <img src="../../assets/img/wuhanImg/wechat_share.png" alt="">
                    <span>微信</span>
                </p>
                <p @click.stop="getimg(2,1)">
                    <img src="../../assets/img/wuhanImg/wechatMonment_share.png" alt="">
                    <span>朋友圈</span>
                </p>
                <p @click.stop="getimg(4,1)">
                    <img src="../../assets/img/wuhanImg/weibo_share.png" alt="">
                    <span>微博</span>
                </p>
                <p @click.stop="getimg(3,1)">
                    <img src="../../assets/img/wuhanImg/qq_share.png" alt="">
                    <span>QQ</span>
                </p>
                <p @click.stop="getimg('savePicture',2)">
                    <img src="../../assets/img/wuhanImg/savePicture.png" alt="">
                    <span>本地保存</span>
                </p>
                
            </div>
            <div class="sharebox">
                 <img class="sharebg" style="width:100%" src="../../assets/img/womensDay/sharebg.png" alt="">
                 <img  v-if="isapp=='0'" class="sharebtn" @click="getimg()" src="../../assets/img/womensDay/shareH5.png" alt="">
            </div>
           
            <!-- H5 海报图片-->
            <div class="copyBox3"  v-show="appShow=='0'">
                <div class="copy">
                    <img @click.stop="hide" class="closeShare" src="../../assets/img/womensDay/close1.png" alt="">
                    <img class="imgpath" crossOrigin="anonymous" style="width:100%;" :src="imgpath" alt="">
                    <p class='h'>长按图片保存后分享</p>
                </div>
            </div>
            <!-- 生成图片的时候给个遮罩层 -->
            <div class="isCeng" v-if="isCeng=='1'"></div>
            <!-- 零元购商品 -->
            <div v-for="oneList in goodsList" :key="oneList.id" class="father">
                <div class="goodsList">
                    <div class="listDivBig"  v-if="oneList.listDivBig.length > 0">
                        <img @click="toDetail(img.id)" v-for="img in oneList.listDivBig" :key="img.id" v-lazy="img.url" alt="">
                    </div>
                    <div class="listDivSmall" v-if="oneList.listDivSmall.length > 0">
                        <img @click="toDetail(img.id)" v-for="img in oneList.listDivSmall" :key="img.id" v-lazy="img.url" alt="">
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { Swipe, SwipeItem } from 'mint-ui';
import { Indicator } from 'mint-ui';
import "mint-ui/lib/style.css" 
import cbct from '../../assets/js/common/base.js';
import Swiper from "swiper";
import axios from 'axios';
import qs from 'qs';
import share from '../../assets/js/common/share.js';
import shareMsg from '../../assets/js/common/shareConfig.js';
import html2canvas from 'html2canvas';
import vueQr from 'vue-qr';
import lrz from 'lrz'
export default {
    name: 'lachinePoster',
   
    data:function(){
        return{
            token2:'',
            salt2:'',
            //节流
            isClick:false,
            //判断是否是app内
            from1:'',
            //显示主持人信息
            isShow:'1',
            //显示端内还是端外分享图片
            appShow:'',
           //是否主持人 1是0否
           star:'',
           //昵称
           userName:'',
           //头像
           userAvatar:'',
           //背景列表
           bgList:[
                {
                    image:require('../../assets/img/womensDay/sharePoster.png'),
                    id:'1',
                },
                // {
                //     image:require('../../assets/img/wuhanImg/sharebg2.png'),
                //     id:'2',
                // },
                // {
                //     image:require('../../assets/img/wuhanImg/sharebg3.png'),
                //     id:'3',
                // }
           ],
           background_list1:[],
           //分享人用户信息
            token:'',
            salt:'',
            //二维码链接
            loginUrl:'',
           //图片
            config:{
                logo:require('../../assets/img/wuhanImg/shareLogo.png'),
                value: ''
            },
            //截取的图片
            imgpath:'',
            imgpath1:'',
            poster_id:'1',
            src1:'',
            shareImg:'',
            //当前div
            divIndex:'0',
            isCeng:'0',
            isS:'0',
            showCopy:false,//显示一键复制弹层
            isapp:'0',//是否是app
            copytxt:'',
            dataUrl:[],//二维码的base64地址
            user_number:'',//主持人时的海报id
            isSpace:0,
            copyIndex:1,
            videoId:'',
            goodsList:[
                {
                    header:'0元秒杀',
                    type:'1',
                    listDivBig:[
                         {
                            url:require("../../assets/img/womensDay/288.png"),
                            id:'288'
                        },
                        {
                            url:require("../../assets/img/womensDay/546.png"),
                            id:'546'
                        },
                        {
                            url:require("../../assets/img/womensDay/652.png"),
                            id:'652'
                        },
                        {
                            url:require("../../assets/img/womensDay/653.png"),
                            id:'653'
                        },
                    ],
                    listDivSmall:[
                        {
                            url:require("../../assets/img/womensDay/587.png"),
                            id:'587'
                        },
                        {
                            url:require("../../assets/img/womensDay/588.png"),
                            id:'588'
                        },
                        {
                            url:require("../../assets/img/womensDay/572.png"),
                            id:'572'
                        },
                        {
                            url:require("../../assets/img/womensDay/586.png"),
                            id:'586'
                        },
                        {
                            url:require("../../assets/img/womensDay/573.png"),
                            id:'573'
                        },
                        {
                            url:require("../../assets/img/womensDay/585.png"),
                            id:'585'
                        },
                        {
                            url:require("../../assets/img/womensDay/582.png"),
                            id:'582'
                        },
                        {
                            url:require("../../assets/img/womensDay/306.png"),
                            id:'306'
                        },
                        {
                            url:require("../../assets/img/womensDay/305.png"),
                            id:'305'
                        },
                        {
                            url:require("../../assets/img/womensDay/44.png"),
                            id:'44'
                        },
                        {
                            url:require("../../assets/img/womensDay/34.png"),
                            id:'34'
                        },
                        {
                            url:require("../../assets/img/womensDay/45.png"),
                            id:'45'
                        },
                        {
                            url:require("../../assets/img/womensDay/40.png"),
                            id:'40'
                        },
                        {
                            url:require("../../assets/img/womensDay/42.png"),
                            id:'42'
                        },
                        {
                            url:require("../../assets/img/womensDay/31.png"),
                            id:'31'
                        },
                    ]
                },
            ],
        }
    },
    components:{
        vueQr
    },
    created(){
        let self =this;
        if(this.$route.query.from1){
            this.from1 = this.$route.query.from1;
        }
        if(this.$route.query.hostName){
            this.hostName = this.$route.query.hostName;
        }
         if(this.$route.query.stationName){
            this.stationName = this.$route.query.stationName;
        }
        this.videoId = this.$route.query.videoId;
         $('title').html('专属分享海报');
        if(this.from1 == 'app'){
            this.isapp = '1';
            window['onWebResponse']=(str)=>{
                self.onWebResponse(str)
            }
            this.getTitle();
        }
      axios.defaults.headers = {
          'Content-Type':'application/x-www-form-urlencoded',
      };
     this.api2.post(this.cbct.https()+'/admin/time', {  
        })
        .then(function (response) {
            if(response.c == self.cbct.code.successRes){
                var timing = response.d.time - Date.parse(new Date()); 
                self.cbct.setCookie('timing',timing);
                self.getUser();
                // setTimeout(function(){
                //     if(self.from1!='app'){
                //         self.getimg()
                //     }
                // },1500)
                } 
        })
        .catch(function (error) {});  
    },
    mounted(){
        var self=this;
       
       
        //  if(Number(window.screen.availHeight) > 667){
        //     $('.swiperbox').css({'margin-top':'.68rem'})
        // }
        // if(this.isapp == '1'){
        //     $('.swiperbox').css('margin','.24rem 0 0.18rem 0')
        // }
        // this.$nextTick(()=>{
        //     self.initSwiper()
        // })
          console.log( this.cbct.https())
         var src = this.cbct.https().split('channels-')[1].split('.')[0];
     
        if(src != ''&& src != undefined){
            if(src != 'dev' && src != 'test'){
                src = '';
            }else{
                src = src+'.';
            }
        }
            // shareMsg.shareConfig(
            //     this.from1,'0','0','贺新春，领红包','恭喜收到，听见广播新年现金红包','http://'+src+'iandwe.com.cn/lachineIndex','https://seefm.oss-cn-beijing.aliyuncs.com/image/recive_hong_bao.jpg','','0'
            // )
           
            this.loginUrl = 'http://channels.h5.'+src+'cbct.cn/womensDayDetails?videoId='+this.videoId+'&isShare=1';
            var shareUrl ='http://channels.h5.'+src+'cbct.cn/womensDayDetails?videoId='+this.videoId+'&isShare=1';
            share.share(shareUrl,'听见最美的声音，做最有魅力的女神','来自'+this.hostName+'主持人的一段真挚祝福','http://img001.seefm.com.cn/image/activity38_1.jpg');
            share.QQshare(shareUrl,'听见最美的声音，做最有魅力的女神','来自'+this.hostName+'主持人的一段真挚祝福','http://img001.seefm.com.cn/image/activity38_1.jpg');
           
    },
   
    methods:{
         //   跳转电商页面
         toDetail(id){
            if(this.from1 == 'app'){
                window.location.href = this.cbct.dsUrl()+'/detail/'+id+'?isToken='+this.cbct.getCookie('ds_token')+'&oId='+this.cbct.getCookie('opendId')+'&from1=app'
            }else{
                window.location.href = this.cbct.dsUrl()+'/detail/'+id+'?isToken='+this.cbct.getCookie('ds_token')+'&oId='+this.cbct.getCookie('opendId')
            }
        },
     
        //二维码base64地址，异步回调
        callback(data,qid){
            // debugger;
            let obj = {data,qid}
            this.dataUrl.push(obj)
        },
          // 嵌入app获取用户登陆状态
        onWebResponse:function(str) {
            var obj=JSON.parse(str);
            var action=obj.action;
            var self=this;
            var content=obj.content;
            if (action=='shareResponse') {
                self.appShow='';
                Indicator.close();
                self.isShow = '1';
                this.isS='1';
                $('html').css('position','static');
            }
            if(action=='setUserInfo'){
                self.token2 = content.token;
                self.salt2 = content.salt;
                if (self.token2=='') {
                    self.cbct.setCookie('token2','TOKEN'); 
                }else{
                    self.cbct.setCookie('token2',self.token2);
                }
                if (self.salt2=='') {
                    self.cbct.setCookie('salt2','SALT'); 
                }else{
                    self.cbct.setCookie('salt2',self.salt2);
                }
              
            }
            
        },
          //登录处理
        gotoLoginPage:function(){
            var self=this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (self.from1 == 'app') {
                    const win = window;
                    var obj={
                        "action": "goToLogin",
                        "content": {
                            'isReturnHomepage':'0'
                        }
                    }
                    if (isAndroid) {
                        App.onAppResponse(JSON.stringify(obj));

                    }
                    if (isIOS) {
                        win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                    }  
            }else{
                this.$router.push({path:'./womensDayLogin'});
            }
        },
        // base64转二进制流
        tofileobj(data) {
            const binary = atob(data.split(',')[1])
            const mime = data.split(',')[0].match(/:(.*?);/)[1]
            const array = []
            for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i))
            }
            const fileData = new Blob([new Uint8Array(array)], {
                type: mime
            })

            const file = new File([fileData], `${new Date().getTime()}.png`, { type: mime })
            return file
        },
        getimg(actionType,isshare){
            let jumptype = isshare;
            this.isCeng='1';
            this.isS='0';
              Indicator.open({
                text: '图片生成中...',
                spinnerType: 'fading-circle'
            });
            $('html').css({'position':'fixed','top':'0','bottom':'0'});
            window.pageYOffset = 0;
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
            let img = new Image();
            img.src = $('.box .bgPic img').attr('src')
    
            img.onload = ()=>{
                setTimeout(() => {
                    var self = this;
                    this.isClick=false;        
                    this.shareImg='';
                    html2canvas(document.querySelector('.box'), {
                        taintTest: true, //在渲染前测试图片(没整明白有啥用)
                        useCORS: true, //使用跨域(当allowTaint为true时这段代码没什么用)
                        width:$('.box').width()-2,//设置canvas尺寸与所截图尺寸相同，防止白边
                        height:$('.sPage').height(),//防止白边
                    }).then((canvas)=>{
                      
                        this.imgpath = canvas.toDataURL('image/png', 1.0); //将图片转为base64, 0-1 表示清晰度
                        lrz(this.imgpath).then(rst => {
                            let form = this.tofileobj(rst.base64)
                            let fd = new FormData()
                            fd.append('name',form)
                            fd.append('type','image')
                            this.api2.post(this.cbct.https()+'/h5/upload-image',fd, this.qs.stringify({      
                            })).then((response)=>{
                               
                                    if(response.c == this.cbct.code.successRes){ 
                                          
                                        self.isClick=true;
                                        self.numbers();
                                        console.log(response.d.url,'response.d.url')
                                        self.shareImg = response.d.url//给客户端传的图片
                                        self.$nextTick(function () {
                                         
                                            self.isCeng='0';
                                            $('html').css('position','static');
                                            Indicator.close();
                                        // if(this.star == '0'){
                                                self.isS='1';
                                        // }
                                            if(this.from1 =='app'){                       
                                                if(jumptype==1){
                                                
                                                    //单独分享
                                                    shareMsg.singleShare(
                                                        'app','1','','','',self.shareImg,'',actionType
                                                    )
                                                }else if(jumptype == 2){
                                                    //本地保存
                                                    shareMsg.onAction(
                                                        'app',actionType,{'shareImage':self.shareImg}
                                                    )
                                                }
                            
                                            }else{
                                                // self.isShow = '0'
                                                self.appShow='0';
                                                $('html').css({'position':'fixed','top':'0','bottom':'0'});
                                            }           
                                        })
                                    }else if(response.c == this.cbct.code.noLogin){
                                        Toast({
                                            message:response.m ,
                                            position: 'center',
                                            duration: 1000
                                        });
                                        timing.time();
                                    }else if(response.c == this.cbct.code.raleNoLogin){
                                        //  self.$router.replace({path:'./fissionLogin'});
                                    }else{
                                        self.isClick=true;
                                        self.isCeng='0';
                                        this.isS='1';
                                        Indicator.close();
                                        Toast({
                                            message:response.m,
                                            position: 'center',
                                            duration: 1000
                                        });
                                    
                                    }
                                }).catch((error)=>{console.log(error);})
                            })
                        });
                       
                        
            }, 2000);
            }
             
        },
        hide:function(){
                this.appShow='';
                this.isShow = '1';
                this.isCeng='0';
                // if(this.star == '0'){
                this.isS='1';
                // }
                Indicator.close();
                $('html').css('position','static');
        },
        //给安卓传title的方法
        getTitle:function(){
            var self=this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            var obj={
                    "action": "setTitle",
                    "content": {
                        'title':'专属分享海报',
                    }
                }
                if (isAndroid){
                    App.onAppResponse(JSON.stringify(obj));
                }
        },
      
         // 用户数加一
        numbers:function(){
            let self = this;
            this.api2.post(this.cbct.https()+'/h5/activity/womendays/increase' , this.qs.stringify({
                id:this.videoId
            })).then((response)=>{
                if(response.c == this.cbct.code.successRes){ 
                   
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message:response.m ,
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                    //  self.$router.replace({path:'./fissionLogin'});
                }else{
                    Toast({
                        message:response.m,
                        position: 'center',
                        duration: 1000   
                    });
                   
                }
            }
            ).catch((error)=>{console.log(error);})
        },
         //获取用户信息
        getUser:function(){
            let self = this;
            this.api2.post(this.cbct.https()+'/h5/user/baseinfo' , this.qs.stringify({
            })).then((response)=>{
                if(response.c == this.cbct.code.successRes){ 
                   this.userName = response.d.nickname;
                   this.userAvatar ='http://seefm.oss-cn-beijing.aliyuncs.com/avatar/'+response.d.avatar;
                
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message:response.m ,
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                   self.gotoLoginPage(); 
                }else{
                    Toast({
                        message:response.m,
                        position: 'center',
                        duration: 1000   
                    });
                   
                }
            }
            ).catch((error)=>{console.log(error);})
        },
       
    },

    filters:{
     
    },
    destroyed: function () {
        Indicator.close();
    }
    
}
</script>
<style>
    .mint-indicator-wrapper{
        z-index: 10000;
    }
     .swiper-button-prev,.swiper-button-next{
        background: none;
    }
</style>
<style scoped lang="scss">
    .sharePosterBox{
        width: 100%;
        height: auto;
        min-height: 100vh;
        display: flex;
        background: rgba(255, 174, 172, 1);
        .sharePoster{
            width: 100%;
            box-sizing: border-box;
            font-size: 0.24rem;
            background: rgba(255, 174, 172, 1);
            // background:url('../../assets/img/wuhanImg/bg2.png') no-repeat;
            // background-size: 100% auto;
            .prev{
                position: absolute;
                left:0.2rem !important;
                top: 48%;
                width: .48rem;
                height: .48rem;
                
                z-index: 5;
            }
            .next{
                position: absolute;
                right:0.2rem !important;
                top:48%;
                width: .48rem;
                height: .48rem;
                z-index: 5;
            }
            .isCeng{
                width: 100%;
                height: 100%;
                position: fixed;  
                top:0;
                left:0;
                background:rgba(17,17,17,0.8); 
                z-index: 99;   
                box-sizing: border-box; 
            }
            .sharebox{
                width: 100%;
                height: auto;
                position: relative;
                .sharebtn{
                    position: absolute;
                    width: 3.26rem;
                    top: -.15rem;
                    right: .28rem;
                }
            }
            .copyBox3{
                width: 100%;
                height: 100%;
                position: fixed;  
                top:0;
                left:0;
                background:rgba(0,0,0,0.4);
                z-index: 99;   
                box-sizing: border-box; 
                .copy{
                    width:6.94rem;
                    height:auto;
                    position: absolute;
                    top:0.26rem;
                    left: 0.28rem;
                    border-radius: .16rem;
                    overflow: hidden;
                    box-sizing: border-box;
                    .h{
                        font-size: .28rem;
                        color: #fff;
                        margin: 0.24rem auto 0; 
                        text-align: center;
                    }
                    .closeShare{
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: .62rem;
                        height: .62rem;
                    }
                    .imgpath{
                        width:6.94rem;
                        height:5.8rem;
                        border-radius: .16rem;
                    }
                }
            }
            .swiperbox{
                width:100%;
                height:5.8rem;
                border-radius: .16rem;
                margin:.22rem auto 0;
                position: relative;
                box-sizing: border-box;
                .swiper-container{
                     border-radius: .16rem;
                }
                .header{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 1rem;
                        background:url('../../assets/img/wuhanImg/shareHeader.png') no-repeat;
                        background-size: 100% 100%;
                        text-align: left;
                        display: flex;
                        z-index: 3;
                        border-radius: .16rem .16rem 0 0;
                        .avatar{
                        width: .76rem;
                        height: .76rem;
                        border-radius: 50%;
                        margin:.12rem .12rem 0 .26rem;
                        box-sizing: border-box;

                        }
                        .name{
                            height: 1rem;
                            line-height: 1rem;
                            display: inline-block;
                            width:2.56rem;
                            white-space:nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #000;
                            font-size: .32rem;
                        }
                    }
                 
                .box{
                    // width:6.64rem;
                    width:6.94rem !important;
                    height:5.8rem;
                    border-radius: .16rem;
                    overflow: hidden;
                    position: relative; 
                    margin: 0 auto;
                    box-sizing: border-box;    
                    .hostbox{
                        position: absolute;
                        top:0;
                        left:0;
                        width: 100%;
                        height:1rem ; 
                        line-height: 1rem;
                        background:url('../../assets/img/wuhanImg/hostBg.png') no-repeat;
                        background-size: 100% auto;
                        z-index: 1; 
                        img{
                           width:.76rem;
                           height: .76rem; 
                           border-radius: 50%;
                           overflow: hidden;
                           float: left;
                           margin:.14rem .16rem 0 .3rem ;
                        }
                        span{
                            float: left;
                            font-size: .32rem;
                            color: #fff;
                        }
                    }
                    
                    .bgPic{
                        position: absolute;
                        top:0;
                        left:0;
                        width:100%;
                        height:5.8rem;
                        border-radius: .16rem;
                        overflow: hidden;
              
                        img{
                            width:100%; 
                            height:5.8rem;
                            border-radius: .16rem;
                        }
                    }
                    .toptxt{
                        position: absolute;
                        left:.1rem;
                        top: 1.16rem;
                        width:3.95rem;
                        text-align: center;
                        .hostName{
                            font-size: .26rem;
                            color: #C43434;
                        }
                        .stationName{
                            font-size: .2rem;
                            color: rgba(196, 52, 52, .5);
                        }
                    }
                     .btmtxt{
                        position: absolute;
                        right:.3rem;
                        bottom: .2rem;
                        color: #812F2F;
                        font-size: .22rem;
                        font-weight: 500;
                        line-height: .3rem;
                        text-align: right;
                    }
                    .lefttxt{
                        position: absolute;
                        left:.3rem;
                        bottom: .25rem;
                        height: .6rem;
                        line-height: .6rem;
                        img{
                            width:.6rem ;
                            height: .6rem;
                            border-radius: 50%;
                            overflow: hidden;
                            float: left;
                        } 
                        .userName{
                            font-size: .26rem; 
                            color: #812F2F;
                            margin-left: .2rem;
                        }
                    }
                    .invitation{
                        position: absolute;
                        right:0.28rem;
                        bottom: 0.76rem;
                        .vue-qr-img{
                            width: 1.44rem;
                            height: 1.44rem;
                            border-radius:.16rem; 
                            text-align: left;
                        }
                        p{
                            width:1.72rem;
                            height:0.36rem;
                            img{
                                width:100%;
                                height:100%;
                                float: left;
                            }
                            // font-size:.24rem;
                            // font-weight:500;
                            // color:rgba(255,255,255,1);
                            // line-height:.3rem;
                            // letter-spacing:.02rem; 
                            // margin-top: .1rem; 
                            // font{
                            //    font-size:.4rem;
                            //    letter-spacing:.02rem; 
                            // }
                        }
                    }
                }
            }
            .txt{
                font-size:0.24rem;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:0.34rem;
            }
            .txt1{
                font-size:0.24rem;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:0.38rem;
            }
            .bottom_btn{
                display: flex;
                font-size: 0.28rem;
                font-weight: 500;
                text-align: center;
                align-content: center;
                justify-content: center;
                margin:1rem auto 0;
                padding-bottom: .28rem;
                
                .download{
                    width:2.62rem;
                    height:.96rem;
                    
                }
                .poster{
                     width:3.83rem;
                    height:.96rem;
                    margin-right: 0.28rem;
                    
                }
            }
            .shareButton{
                display: flex;
                color:#fff;
                justify-content: space-around;
                // margin-top: 0.18rem;
                padding-bottom: 0.28rem;
                p{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    font-size:0.24rem;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(255,255,255,0.41);
                    line-height:0.34rem;
                    img{
                        width:0.84rem;
                        height:0.84rem;
                        border-radius: 50%;
                        margin-bottom: 0.14rem;
                    }
                }
            }
            .easyCopy{
                width: 100%;
                height: .96rem;
                line-height: .96rem;
                text-align: center;
                position: relative;
                font-weight:500;
                color:rgba(255,255,255,1);
                font-size: .3rem;
                img{
                    position: absolute;
                    right: 0;
                    top: .28rem;
                    width: 1.58rem;
                    height: .4rem;
                }
            }
            .isCeng1{
                width: 100%;
                height: 100%;
                position: fixed;  
                top:0;
                left:0;
                background:rgba(0,0,0,0.69);
                z-index: 99;   
                box-sizing: border-box; 
                .content{
                    position: absolute;
                    left:50%;
                    top:50%;
                    transform: translate(-50%,-50%);
                    // margin:3.6rem 0.64rem 0 0.66rem;
                    width:6.2rem;
                    height:auto;
                    background: #fff;
                    z-index: 100;
                    padding:0 0.28rem 0 0.28rem;
                    font-size:0.36rem;
                    font-family:PingFangSC-Medium,PingFang SC;
                    font-weight:bold;
                    color:rgba(0,0,0,0.8);
                    // line-height:30px;
                    box-sizing: border-box;
                    text-align: center;
                    border-radius: 0.16rem;
                    // color:#fff;
                    .text{
                        // width:5.6rem;
                        padding: 0 0.16rem 0.52rem 0.16rem;
                        border-bottom: 1px solid rgba(0,0,0,.1);
                        line-height:0.6rem;
                        text-align: left;
                    }
                    .copytxt{
                        margin:0.32rem 0 0.4rem 0;
                        color:rgba(42,131,199,1);
                        font-weight:500;
                    }
                    .huan{
                        font-size:0.28rem;
                        font-weight:500;
                        color:rgba(143,155,178,1);
                        margin:0.3rem .32rem 0.48rem 0;
                        text-align: right;
                        display: flex;
                        img{
                            width:0.32rem;
                            height:0.32rem;
                            margin-left: auto;
                            margin-right: 0.2rem;
                            float: left;
                        }
                    }
                }
            }
            .father{
                height: auto;
                box-sizing: border-box;
                // background: url('../../assets/img/wuhanImg/goodsListbg.png') no-repeat;
                // background-size: 100% 9.02rem;
                // padding: 0.03rem;
                // margin-top: 0.64rem;
                margin-bottom: 0.3rem;
                margin-top: -.1rem;
                position: relative;
                z-index: 2;
                padding: 0 0.12rem;
                .goodsList{
                    width: 7.21rem;
                    height: auto;
                    border-radius: 0.08rem;
                    .dis{
                        text-align: center;
                        font-size: 0.32rem;
                        font-weight: 600;
                        color: #763205;
                        line-height: 1;
                        padding:0.12rem 0;
                        width: 3.36rem;
                        margin-left: 1.93rem;
                        margin-bottom: 0.16rem;
                        height: auto;
                        border-radius: 0px 0px 0.22rem 0.22rem;
                        box-sizing: border-box;
                        img{
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                      .listDivBig{
                        width: 6.96rem;
                        margin: 0 0.13rem 0.04rem 0.11rem; 
                        display: flex;
                        display: -webkit-flex;
                        justify-content: space-between;
                        flex-direction: row;
                        flex-wrap: wrap;
                        height: auto;
                        img{
                            width: 3.44rem;
                            height: 3.6rem;
                            margin-bottom: 0.08rem;
                        }
                    }
                    .listDivSmall{
                        width: 6.92rem;
                        margin: 0 0.14rem 0.08rem 0.14rem; 
                        display: flex;
                        box-sizing: border-box;
                        display: -webkit-flex;
                        justify-content: space-between;
                        flex-direction: row;
                        flex-wrap: wrap;
                        height: auto;
                        padding-bottom: 0.2rem;
                        img{
                            width: 2.26rem;
                            height: 3.6rem;
                            margin-bottom: 0.08rem;
                        }
                    }
                }
            }
      
        }
      }
</style>
